import { FC } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";

import Button from "../Button/Button";
import { ForgotPasswordPayload } from "../../store/auth/types";
import {
  selectAuthErrorResetPassword,
  selectAuthLoading,
  selectAuthSuccessResetPassword
} from "../../store/selectors/auth";
import FormikInputField from "../FormikField/FormikInputField/FormikInputField";
import { forgotPasswordSchema } from "../../utils/validators";
import AuthLayout from "../../layout/AuthLayout/AuthLayout";
import { forgotPasswordUser } from "../../store/auth/slice";

import styles from "./ForgotPassword.module.css";



const ForgotPassword: FC = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectAuthLoading);
  const successResetPassword = useSelector(selectAuthSuccessResetPassword);
  const errorResetPassword = useSelector(selectAuthErrorResetPassword);

  const handleForgotPassword = (values: ForgotPasswordPayload) => {
    dispatch(forgotPasswordUser(values));
  };

  const renderForm = () => {
    return (
      <Formik
        initialValues={{ email: "" }}
        validationSchema={forgotPasswordSchema}
        onSubmit={(val) => handleForgotPassword(val)}
      >
        {() => (
          <Form>
            <div className={styles["form__field"]}>
              <FormikInputField
                placeholder="Email"
                type="email"
                name="email"
                id="email"
              />
            </div>

            <Button
              size="lg"
              className={styles["form__submit"]}
              disabled={loading}
              label="Continue"
              typeStyle="fill-dark"
            />

            {errorResetPassword && <p className={styles["form__error"]}>{errorResetPassword}</p>}
          </Form>
        )}
      </Formik>
    )
  }

  const renderSuccess = () => {
    return (
      <div className={styles["forgot-password__success"]}>
        <p>Check your email for a link to reset your password.</p>
      </div>
    )
  }

  return (
    <AuthLayout>
      <div className={styles["forgot-password"]}>
        <header className={styles["forgot-password__header"]}>
          <h1 className={styles["forgot-password__title"]}>Forgot password?</h1>
        </header>
        {successResetPassword ? renderSuccess() : renderForm()}
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
